module.exports = __webpack_public_path__ + "img/alaves-logo-icon.b745f227.png";